import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MessageList = _resolveComponent("MessageList");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        cancelBtnTxt: _ctx.neverClose ? '' : 'Ok',
        actionBtnTxt: "",
        onOnClosed: _ctx.onClosed,
        variant: _ctx.variantToUse,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createVNode(_component_MessageList, { messages: _ctx.simpleMsgs }, null, 8, ["messages"])
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "cancelBtnTxt", "onOnClosed", "variant", "onOnUserArgChanged"]));
}
